import React, { useState } from 'react'

import { Grid, Paper, TablePagination } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { Actions } from './components'
import {
  ChipProgressStatus,
  ChipStatus,
  StatusesTab,
} from '../../../components'

import usePagination from 'hooks/usePagination'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

const ImSupplierTable = ({ filter }) => {
  const [selectedTab, setSelectedTab] = useState('all')

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const { ACTIVE_STATUS, INACTIVE_STATUS } = constants.companySuppliers

  const filterStatus = () => {
    if (selectedTab === 'all') return [ACTIVE_STATUS, INACTIVE_STATUS]

    return selectedTab
  }

  const { response, isLoading } = useFetch(
    service.dponet.suppliers.supplierIndex,
    {
      status: filterStatus(),
      perPage,
      page,
      ...filter.filters,
    },
    [filter.filters, perPage, page, selectedTab],
  )

  const companySuppliers = response?.data?.companySuppliers || []

  return (
    <Paper component={Grid} container>
      <Grid item xs={12}>
        <StatusesTab
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          filter={filter}
          searchField="companyCpfOrCompanyCnpjOrCompanyName"
        />
      </Grid>
      <Grid item xs={12}>
        <PerfectScrollbar>
          <Table
            emptyMessage="Nenhuma empresa encontrada"
            isLoading={isLoading}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Razão Social</TableCell>
                <TableCell>Documento</TableCell>
                <TableCell align="center">Prazo</TableCell>
                <TableCell align="center">Tipo</TableCell>
                <TableCell align="center">Progresso</TableCell>
                <TableCell align="center">Conformidade</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell
                  id={
                    constants.tours.thirdPartyManagements.STEPS
                      .QUESTIONNAIRES_RECEIVED[2]
                  }
                  align="right"
                >
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {companySuppliers?.map((companySupplier) => (
                <TableRow key={companySupplier?.id}>
                  <TableCell>{companySupplier?.id}</TableCell>
                  <TableCell>{companySupplier?.company?.name || '-'}</TableCell>
                  <TableCell>{companySupplier?.company?.document}</TableCell>
                  <TableCell align="center">
                    {companySupplier?.endDate || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {companySupplier?.preAvaliation
                      ? 'Pré-Avaliado'
                      : 'Fornecedor'}
                  </TableCell>
                  <TableCell align="center">
                    <ChipProgressStatus
                      progressStatus={companySupplier?.progressStatus}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {companySupplier?.complianceGap || '-'}
                  </TableCell>
                  <TableCell align="center">
                    <ChipStatus status={companySupplier?.status} />
                  </TableCell>
                  <TableCell align="right">
                    <Actions companySupplier={companySupplier} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </PerfectScrollbar>
      </Grid>
    </Paper>
  )
}

export default ImSupplierTable
